const common = {
    sysDictDataList: '/sys/dict/data/list',
    commonGetDeptTree: '/common/getDeptTree',
    commonGetDeptTreeCycle: '/common/getAuthDeptTree-defaultCycle',
    apiLoginLocal: '/api/login/local',
    apiLoginLogout: '/api/login/logout',
    commonInfo: '/common/info',
    fileDownload: '/sys/file/download',
    flowInfoQueryFlowInfo: '/flowInfo/queryFlowInfo',
    homepageGetUserLang: '/homepage/getUserLang',
    homepageChangeUserLang: '/homepage/changeUserLang',
    sysUserLoadMyMenu: '/sys/user/loadMyMenu',
    sysAuthRoleGetHrExclusiveRoles: '/sys/auth/role/myRoleByMenuCode',
    sysAuthRoleMyRoleByMenuId: '/sys/auth/role/switchRole',
    sysTaskPage: '/sysTask/page',
    userIndex: '/gm/redirect',
    clearRole: '/sys/auth/role/clearRole',
    getRoleType: '/sys/auth/role/getRoleType',
    checkCurrLanguage: '/homepage/firstSetUserLang',
    homepageHrTodo: '/homepage/hrTodo',
    summaryGetMyTeam: '/summary/getMyTeam',
}

export default common;